import isNil from 'lodash/isNil';
import { object, string, number, literal, array, discriminatedUnion, ZodIssueCode } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { zodIncentivizeResponsesSchema } from '@occc-app/routes/Wallet/validation';
import { IS_REQUIRED, isGreaterThan, isLessThan } from '@occc-app/lib/constants/validationMessages';
import { Max32bitIntSchema } from '@occc/validation';

export const baseConfigureFormSchema = object({
  name: string({ required_error: IS_REQUIRED }).trim().min(1),
  description: string().nullable().optional(),
  question: string({ required_error: IS_REQUIRED }).trim().min(1),
  incentivizeResponses: zodIncentivizeResponsesSchema,
});

const singleChoiceSchema = baseConfigureFormSchema.extend({
  questionType: literal('SurveyQuestionSingleChoice'),
  options: array(string({ required_error: IS_REQUIRED }).trim().min(1)),
});

const multipleChoiceSchema = baseConfigureFormSchema.extend({
  questionType: literal('SurveyQuestionMultipleChoice'),
  options: array(string({ required_error: IS_REQUIRED }).trim().min(1)),
});

const intSliderSchema = baseConfigureFormSchema.extend({
  questionType: literal('SurveyQuestionIntSlider'),
  rangeMin: Max32bitIntSchema(number({ required_error: IS_REQUIRED })),
  rangeMax: Max32bitIntSchema(number({ required_error: IS_REQUIRED })),
});

export const configureFormSchema = discriminatedUnion('questionType', [
  singleChoiceSchema,
  multipleChoiceSchema,
  intSliderSchema,
]).superRefine((val, ctx) => {
  if (val.questionType !== 'SurveyQuestionIntSlider') return;

  if (!isNil(val?.rangeMax) && val.rangeMin >= val.rangeMax) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: isGreaterThan(val.rangeMin),
      path: ['rangeMax'],
    });
  }

  if (!isNil(val?.rangeMin) && val.rangeMin >= val.rangeMax) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: isLessThan(val.rangeMax),
      path: ['rangeMin'],
    });
  }
});

export const validateConfiguration = makeValidate(configureFormSchema);
